const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'scroll',
  },

  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    borderBottom: '1px solid #DFE2E5',
    alignItems: 'center',
    height: '62px',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessagesList/styles.js